import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=55c010c8&"
import script from "./showcase.vue?vue&type=script&lang=js&"
export * from "./showcase.vue?vue&type=script&lang=js&"
import style0 from "./showcase.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports